<template>
    <div>
        <label for="duration">Varighed</label>

        <p v-if="errorMsg" class="error">{{ errorMsg }}</p>

        <select id="duration" required v-model="duration_pick" @change="selectIt(duration_pick)">
            <option v-for="c in choices" :value="c">
                {{ c.label }}
            </option>
        </select>
    </div>

</template>

<script>

    import { dateDjango2js, dateJs2django } from '../../utils/Filters.js'
    import axios from '../../utils/Http.js'

    export default {
        props: {
            interval: {
                type: Number,
                default: 1800000, // default interval is 30 minutes in milliseconds    
            },
            max: undefined, // max duration in milliseconds
            errorMsg: null
        },
        data: function() {
            return {
                duration_pick: null,
                choices: []
            }
        },
        computed: {
            duration: function() {
                return this.$store.getters.getDuration
            },
            resource: function() {
                return this.$store.getters.getResource
            },
            startdatetime: function() {
                return this.$store.getters.getStartDateTime
            }
        },
        watch: {
            startdatetime: function() {
                this.update()
            }
        },
        methods: {
            update: function() {
                this.duration_pick = this.duration
                this.fetchAvailableTimes()
            },
            fetchAvailableTimes: function() {
                if (this.resource && this.startdatetime) {
                    let start = this.startdatetime,
                        end = new Date( new Date(this.startdatetime).setHours(23,59) )
                    axios({
                        url: `/booking/resource/${ this.resource.id }/availability/?start=${ encodeURIComponent(dateJs2django(start)) }&end=${ encodeURIComponent(dateJs2django(end)) }`,
                        method: 'get',
                        headers: {
                            'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                        }
                    })
                    .then(res => {
                        let range = res.data[0] // The first time range is the one closest to our wanted start time
                        this.choices = this.makeChoices(this.interval, range)
                    })
                    .catch(err => console.log(err))
                }
            },
            makeChoices: function(interval, time_range) {
                let c = [],
                    start = dateDjango2js(time_range.start).getTime(),
                    end = dateDjango2js(time_range.end).getTime(),
                    range = end - start

                if (this.max && this.max < range) {
                    range = this.max
                }

                for (let s = interval; s <= range; s = s + interval) {
                    let l = `${ (s/3600000) } timer`
                    // In special cases, set another label for available time
                    // This should be replaced in a translatable setup
                    if (s === 1800000) {
                        l = '30 minutter'
                    } else if (s === 3600000) {
                        l = '1 time'
                    } else if (s === 5400000) {
                        l = '1.5 time'
                    }
                    c.push({
                        label: l,
                        value: s
                    })
                }
                return c
            },
            selectIt: function(t) {
                this.$store.commit('setDuration', this.duration_pick)
                this.$emit('duration-pick', t)
            }
        },
        created: function() {
            this.update()
        }
    }

</script>

<style lang="scss">

    #duration {

    }

</style>